import React from "react";
import NavBar from "../Header/NavBar/NavBar";
import BigSlider from "./../Header/BigSlider/BigSlider";
import Banner1 from "./Banner1/Banner1";
import Banner2 from "./Banner2/Banner2";
import FeaturedClasses from "./FeaturedClasses/FeaturedClasses";
import Trainers from "./Trainers/Trainers";
import Workout from "./Workout/Workout";
import GymInfo from "./GymInfo/GymInfo";
import Services from "./Services/Services";
import AboutClub from "./AboutClub/AboutClub";
import ContactUs from "./ContactUs/ContactUs";
import Banner from "./Banner/Banner";
import Footer from "./../Footer/Footer";
import Review from "./Review/Review";
import ReviewRating from "./ReviewRating/ReviewRating";
import SmSlider from "../Header/SmSlider/SmSlider";
const Home = () => {
  return (
    <div>
      <NavBar />
      <BigSlider />
      <SmSlider />
      <GymInfo />
      <Banner />
      <Workout />
      <Banner1 />
      <FeaturedClasses />
      <Banner2 />
      <Services />
      <Trainers />
      <Review />
      <ReviewRating />
      <AboutClub />
      <ContactUs />
      <Footer />
    </div>
  );
};

export default Home;
